import { suffixPending, suffixFulfilled, suffixRejected } from "actions";
import http from "helpers/APIHelper";
import { getSessionByKey } from "helpers";
import { map } from 'rxjs/operators';
import { httpStatusEnum } from 'appconstants';
import { getProtocolDetails } from "../protocoldetail";

export const ADMIN_ACTIONS = {
  GET_ADMIN_DATA: '@protocol/admin/getAll'
};


// ADDED APM Chnaged need to be deleted
export const getAdminInfoAction = (token, loggerInfo, protocolNumber) => (dispatch, getState) => {
  dispatch({
    type: ADMIN_ACTIONS.GET_ADMIN_DATA + suffixPending
  });
  http
    .getWithToken(
      `protocol-data-service/${getSessionByKey(
        "prt_url_ver"
      )}/admin/protocols/number/${protocolNumber}/flags`,
      token,
      loggerInfo
    )
    .subscribe(
      (resp) => {
        dispatch({
          type: ADMIN_ACTIONS.GET_ADMIN_DATA + suffixFulfilled,
          payload: resp.response
        });
      },
      (error) => {
        dispatch({
          type: ADMIN_ACTIONS.GET_ADMIN_DATA + suffixRejected,
          payload: error
        });
      }
    );
};


export const updateAdminFieldsAction = (token, loggerInfo, postBody) => (
  dispatch,
  getState
) => {
  const { prtId, protocolNumber } = getState().prtDetails.prtInfo;

  return http.putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/admin/protocols/id/${prtId}/flags`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getAdminInfoAction(
            token,
            loggerInfo,
            protocolNumber
          )
        );
      }
      return resp;
    })
  );
}

export const updateGroupStatusAction = (token, loggerInfo, postBody) => (
  dispatch,
  getState
) => {
  const { protocolNumber, prtId } = getState().prtDetails.prtInfo;
  return http.putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/admin/protocols/id/${prtId}/groupstatus`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getProtocolDetails(
            token,
            loggerInfo,
            protocolNumber
          )
        );
      }
      return resp;
    })
  );
};

export const updateStatusTransaction = (token, loggerInfo, postBody) => (
  dispatch,
  getState
) => {
  const { protocolNumber } = getState().prtDetails.prtInfo;
  return http.putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/admin/protocols/number/${protocolNumber}/transaction/generate`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getProtocolDetails(
            token,
            loggerInfo,
            protocolNumber
          )
        );
      }
      return resp;
    })
  );
}

export const createUnregisterStudy = (token, loggerInfo, postBody) => () => {
  return http.putWithToken(
    `protocol-data-service/${getSessionByKey('prt_url_ver')
    }/admin/protocols/unregisteredStudy`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      return resp;
    })
  );
};
